import { h, Fragment } from "preact";
import { useMemo } from "preact/hooks";
import ProductOptionSwatchesGroup from "./product-option-swatches-group";
import ProductOptionSwatchHeader from "./product-option-swatch-header";
import sortMaterials from "../../helpers/sortMaterials/sortMaterials";

export default function ProductOptionSwatchesGrouped({
  optionValues,
  optionName,
  optionLabel,
  updateOptionValue,
  selectedOptionValue,
  disabledOptionValues = [],
  truncate = false,
  swatchRequestUrl,
}) {
  const optionsByGroup = useMemo(() => {
    const groups = {};
    optionValues.forEach((optionValue) => {
      if (!optionValue.materialGroup) {
        optionValue.materialGroup = optionLabel;
      }

      const key = optionValue.materialGroup;

      if (!(key in groups)) {
        groups[key] = {
          optionValues: [],
          madeToOrder: optionValue.madeToOrder,
        };
      }

      groups[key].optionValues.push(optionValue);
    });

    return groups;
  }, [optionValues, optionLabel]);

  return (
    <div
      className={`product-options__option product-options__option--swatches-grouped`}
    >
      <ProductOptionSwatchHeader
        optionName={optionName}
        optionLabel={optionLabel}
        selectedOptionValue={selectedOptionValue}
        swatchRequestUrl={swatchRequestUrl}
      />
      <div className="product-options__option-content">
        <div className="product-options__option-content-inner">
          <div className="product-options__swatch-groups">
            {Object.entries(optionsByGroup)
              .sort(([_a, groupA], [_b, groupB]) =>
                sortMaterials(
                  groupA?.optionValues?.[0].materialGroup,
                  groupB?.optionValues?.[0].materialGroup,
                ),
              )
              .map(([groupTitle, { optionValues, madeToOrder }]) => (
                <ProductOptionSwatchesGroup
                  groupTitle={groupTitle}
                  optionValues={optionValues}
                  key={groupTitle}
                  selectedOptionValue={selectedOptionValue}
                  disabledOptionValues={disabledOptionValues}
                  updateOptionValue={updateOptionValue}
                  optionName={optionName}
                  truncate={truncate}
                />
              ))}
          </div>
        </div>
      </div>
    </div>
  );
}
